module.exports = __webpack_public_path__ + "img/Bank.cb905cbe.svg";